function filter() {
  const filterBtn = document.querySelectorAll(".catalog__filter-button");

  if (filterBtn.length > 0) {
    const products = document.querySelectorAll(".catalog__list-item");

    filterBtn.forEach((el) => {
      el.addEventListener("click", function (e) {
        let targetData = this.dataset.filter;

        filterBtn.forEach((el) => el.classList.remove("active"));
        this.classList.add("active");

        if (this.dataset.filter != "all") {
          products.forEach((el) => {
            el.style.display = "none";
          });

          products.forEach((el) => {
            if (el.dataset.filter === targetData) {
              el.style.display = "flex";
            }
          });
        } else {
          products.forEach((el) => {
            el.style.display = "flex";
          });
        }
      });
    });
  }

  /* 
        Настройка фильтрации с Главной страницы
    */
  const homeCatalogLinks = document.querySelectorAll(".home__catalog-link");

  if (homeCatalogLinks.length > 0) {
    homeCatalogLinks.forEach((link) => {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // Предотвращаем переход по ссылке

        const filter = this.getAttribute("data-filter"); // Получаем значение из data-filter

        window.location.href =
          `${window.location.href}/catalog?filter=` +
          encodeURIComponent(filter); //Записываем его в браузерную строку
      });
    });
  }

  // Получаем значение фильтра из URL
  const urlParams = new URLSearchParams(window.location.search);
  const filter = urlParams.get("filter");

  if (filter) {
    // Если фильтр есть, скрываем/показываем элементы на странице каталога
    const catalogItems = document.querySelectorAll(".catalog__list-item");

    catalogItems.forEach((item) => {
      if (item.getAttribute("data-filter").includes(filter)) {
        item.style.display = "flex";
      } else {
        item.style.display = "none";
      }
    });

    //Выбираем активную кнопку фильтрации
    filterBtn.forEach((el) => {
      el.classList.remove("active");

      if (el.getAttribute("data-filter").includes(filter)) {
        el.classList.add("active");
      }
    });
  } else {
    filterBtn[0].classList.add("active");
  }
}

export default filter;
